// import useCheckableItems from '@hook/useCheckableItems'
import cn from 'clsx'
import { BsSortDown, BsSortUp } from 'react-icons/bs'

// import Checkbox from '$components/Forms/Checkbox'
import { Link } from 'react-router-dom'

const OperatorsTable = ({
    className,
    operators,
    order,
    changeOrder,
}) => {
    
    // const {
    //     allChecked,
    //     someChecked,
    //     hasChecked,
    //     toggleChecked,
    //     toggleAllChecked,
    // } = useCheckableItems(operators?.rows ?? [])
    
    return (
        
        <table className={cn('table-auto OperatorsTable ', className)}>
            <thead>
                <tr>
                    {/* <th className="w-10">
                        <Checkbox
                            checked={allChecked}
                            indeterminate={someChecked}
                            onChange={toggleAllChecked} />
                    </th> */}
                    <th onClick={changeOrder} className="cursor-pointer">
                        <div className="flex items-center gap-2">
                            <span>Operator</span>
                            {order === 'ASC' ? <BsSortDown /> : <BsSortUp />}
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                {operators?.rows?.map(it => (
                    <tr key={it.operator}>
                        {/* <td>
                            <Checkbox
                                checked={hasChecked(it.id)}
                                onChange={() => toggleChecked(it.id)} />
                        </td> */}
                        <td>
                            <Link to={`/checks/operators/${it.operator}`}>
                                {it.operator}
                            </Link>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        
    )
    
}

export default OperatorsTable
